import * as yup from 'yup'
import {
  requiredString, state, stringNullable
} from '../yup/schemas.js'

export const studentSchema = yup.object({
  id: requiredString.uuid(),
  firstName: requiredString,
  lastName: requiredString,
  name: requiredString,
  email: requiredString.email().toLowerCase(),
  state: state.required(),
  affiliatedSchool: stringNullable,
  zip: requiredString,
  phone:requiredString.phone(),
  password: requiredString.password(),
  applicationData: yup.string()
}).objectRequired()

const createStudentSchema = studentSchema.pick([
  'firstName',
  'lastName',
  'email',
  'state',
  'zip',
  'phone',
  'password',
  'affiliatedSchool',
  'applicationData'
])
const getStudentSchema = studentSchema.pick(['id'])

const changeSchoolStudentSchema = studentSchema.pick([
  'affiliatedSchool'
])

const createStudentSchemas = { front: createStudentSchema, back: createStudentSchema }
const changeSchoolStudentSchemas = { front: changeSchoolStudentSchema, back: changeSchoolStudentSchema }
const getStudentSchemas = { back: getStudentSchema }


export default {
  getStudentParams: getStudentSchemas,
  createStudent: createStudentSchemas,
  changeStudentSchool: changeSchoolStudentSchemas
}
